module.exports = __webpack_public_path__ + "img/touxiang.088982c7.png";